import { Component, OnDestroy, signal, Signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  ApplicationAppEntityApplicationRead
} from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { stages } from '../../placement-advertising.routes';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AccordionGroupComponent } from '../../../../../../common/accordion-group/accordion-group.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import { AccordionItemComponent } from '../../../../../../common/accordion-item/accordion-item.component';
import {
  AdPlacementRoadOccupationForm,
  AdPlacementRoadOccupationFormValue, occupationsToAdPlacementRoadOccupationFormValues
} from './forms/ad-placement-road-occupation.form';
import {
  AdPlacementRoadOccupationFormComponent
} from './components/ad-placement-road-occupation-form/ad-placement-road-occupation-form.component';
import { updateAdPlacementOccupations } from '../../../../../../store/actions/application.actions';
import {
  AdPlacementOccupationPreviewComponent
} from './components/ad-placement-occupation-preview/ad-placement-occupation-preview.component';

@Component({
  selector: 'app-ad-placement-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    AccordionGroupComponent,
    AlertComponent,
    AccordionItemComponent,
    AdPlacementRoadOccupationFormComponent,
    AdPlacementOccupationPreviewComponent
  ],
  providers: [
    AdPlacementRoadOccupationForm
  ],
  templateUrl: './ad-placement-section.component.html'
})
export class AdPlacementSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchOccupations: Subscription = toObservable(this.application).subscribe((app) => {
    this.roadOccupations.set(occupationsToAdPlacementRoadOccupationFormValues(app));
  });

  public roadOccupations: WritableSignal<AdPlacementRoadOccupationFormValue[]> = signal([]);

  public showItemForm: boolean = false;

  public currentIndex: number | undefined;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store,
    public form: AdPlacementRoadOccupationForm
  ) {
  }

  public onAddOccupation(): void {
    this.showItemForm = true;
    this.currentIndex = undefined;
  }

  public onEditOccupation(event: Event, i: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.currentIndex = i;
    this.showItemForm = true;
    this.form.patchFormValues({
      ...this.roadOccupations()[i]
    });
  }

  public onRemoveOccupation(i: number, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.roadOccupations.update(v => {
      v.splice(i, 1);
      return v;
    });
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public onUpdateOccupations(roadOccupation: AdPlacementRoadOccupationFormValue): void {
    if (this.currentIndex !== undefined) {
      this.roadOccupations.update(v => {
        const arr = [...v];
        arr[this.currentIndex || 0] = roadOccupation;
        return arr;
      });
      this.currentIndex = undefined;
    } else {
      this.roadOccupations.update(v => ([
        ...v,
        roadOccupation
      ]));
    }
    this.showItemForm = false;
    this.form.reset();
  }

  public submitAndGoNext(): void {
    if (this.roadOccupations().length) {
      this.store$.dispatch(updateAdPlacementOccupations({
        application: this.application(),
        occupations: this.roadOccupations(),
        successFnc: (applicationId) => {
          this.router.navigate(
            ['../inwestor'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    }
  }

  public ngOnDestroy(): void {
    this.fetchOccupations.unsubscribe();
  }
}
